import * as React from "react";

function ArrowSmUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 11l5-5m0 0l5 5m-5-5v12"
  }));
}

export default ArrowSmUpIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@heroicons/react/outline/esm/ArrowSmUpIcon.js
// module id = 1249
// module chunks = 0